import script from "./ActionContentForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionContentForm.vue?vue&type=script&lang=ts&setup=true"

import "./ActionContentForm.vue?vue&type=style&index=0&id=0a5c6f42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a5c6f42"]])

export default __exports__